<template lang="pug">
ValidationProvider(name="Haupthaus" :rules="rules" v-slot="{ errors, valid }")
  b-field(label="Haupthaus" label-position="on-border"
          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
    b-select(v-model="innerValue")
      option(:value="null") ---
      option(v-for="parent in parents" :value="parent.id") {{parent.name}}
</template>

<script>
export default {
  props: {
    rentObjectTypeId: [Number, String],
    rules: {
      type: [Object, String],
      default: ""
    },
    value: {
      type: null
    }
  },
  data() {
    return {
      haupthausId: null,
      innerValue: ""
    };
  },
  computed: {
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    },
    parents() {
      if (!this.haupthausId) return [];

      return this.$store.getters["rentObjects/getByRentObjectTypeId"](
        this.haupthausId
      );
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  async mounted() {
    await this.$store.dispatch("rentObjectTypes/findAll");
    const haupthaus = this.rentObjectTypes.find(r => r.name === "Haupthaus");
    if (haupthaus) this.haupthausId = haupthaus.id;
  }
};
</script>